import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: 'p5dh9qkt',
  dataset: 'production',
  useCdn: process.env.NODE_ENV === 'production',
  apiVersion: "2021-03-25"
});
